import {AfterViewInit, Component, Inject, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {MatStepperModule} from "@angular/material/stepper";
import {FormArray, FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatSelectChange, MatSelectModule} from "@angular/material/select";
import {MatInputModule} from "@angular/material/input";
import {MatDivider} from "@angular/material/divider";
import {CurrencyPipe, DatePipe, NgClass, NgForOf, NgIf} from "@angular/common";
import {
    BookingAssignment,
    ExpenseAssigment,
    RuleTargetType,
    TransactionRule,
    TransactionRuleCondition
} from "../../../models/transactionRule.interface";
import {TransactionsRulesService} from "../../../services/transactionsRules.service";
import {convertTimestamp} from "../../../../../../helpers";
import {fuseAnimations} from "@fuse/animations";
import {
    AlgoliaAutocompleteNewComponent
} from "@shared/algolia/components/algolia-autocomplete-new/algolia-autocomplete-new.component";
import {ImgFallbackModule} from "ngx-img-fallback";
import {MatChipAvatar, MatChipListbox, MatChipOption, MatChipRemove, MatChipsModule} from "@angular/material/chips";
import {MatTooltip} from "@angular/material/tooltip";
import {BankAccount, BankAccounts} from "@bankAccounts/models";
import instantsearch from "instantsearch.js";
import {environment} from "@env/environment";
import {configure} from "instantsearch.js/es/widgets";
import {debounce, omit, pick, uniq} from "lodash-es";
import hits from 'instantsearch.js/es/widgets/hits/hits';
import {NgxCurrencyDirective} from "ngx-currency";
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from "@angular/material/datepicker";
import {MatRadioModule} from "@angular/material/radio";
import {FormatAddressPipe, ToDatePipe} from "@shared/pipes";
import {FuseAlertComponent} from "@fuse/components/alert";
import {FuseCardComponent} from "@fuse/components/card";
import {MatLine} from "@angular/material/core";
import {ManagementType, Property} from "@properties/models/property.interface";
import {NahausBookingsAccount} from 'app/modules/admin/bookingsAccounts/models/nahausBookingsAccount.interface';
import {MatCheckboxChange, MatCheckboxModule} from '@angular/material/checkbox';
import {MatSnackBar, MatSnackBarModule} from '@angular/material/snack-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {TransactionRuleReferenceTextPipe} from "../../../pipes/transaction-rule-reference-text.pipe";
import {TransactionRuleOperatorTextPipe} from "../../../pipes/transaction-rule-operator-text.pipe";
import {PropertyUnit} from '@properties/features/units/models/unit.interface';
import {UnitsService} from '@properties/features/units/services/units.service';
import {MatListModule, MatSelectionListChange} from '@angular/material/list';
import {PeriodsService} from '@properties/features/units/features/period/services/periods.service';
import {map, skipWhile, startWith, Subject, takeUntil} from 'rxjs';
import {QuerySnapshot} from "@angular/fire/compat/firestore";
import {PropertyUnitPeriod} from '@properties/features/units/features/period/models/property.unit.period.interface';
import {
    ManagementPeriodsService
} from '@properties/features/units/features/management/services/managementPeriods.service';
import {ManagementUnitPeriod} from '@properties/features/units/features/management/models/managementUnitPeriod';
import {
    TransactionRuleActivity
} from '../../transactions-rules-list/activities/models/transactionRuleActivity.interface';
import firebase from 'firebase/compat';
import {TransactionsRulesActivitiesService} from '../../../services/transactions-rules-activities.service';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';


export interface TransactionRuleDialogData {

    rule: TransactionRule;
}

@Component({
    selector: 'create-transaction-rule-dialog',
    templateUrl: './create-transaction-rule-dialog.component.html',
    styleUrls: ['./create-transaction-rule-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    standalone: true,
    imports: [MatRadioModule, MatButtonModule, MatDialogModule, MatIconModule, MatSnackBarModule, MatListModule, ToDatePipe, DatePipe, CurrencyPipe, MatSlideToggleModule, MatProgressSpinnerModule, MatStepperModule, MatCheckboxModule, MatChipsModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule, MatInputModule, MatDivider, NgIf, NgClass, AlgoliaAutocompleteNewComponent, ImgFallbackModule, MatChipAvatar, MatChipListbox, MatChipRemove, NgForOf, MatTooltip, MatChipOption, NgxCurrencyDirective, MatDatepicker, MatDatepickerInput, MatDatepickerToggle, FormatAddressPipe, FuseAlertComponent, FuseCardComponent, MatLine, TransactionRuleReferenceTextPipe, TransactionRuleOperatorTextPipe],
    providers: [TransactionsRulesService, TransactionsRulesActivitiesService]
})
export class CreateTransactionRuleDialogComponent implements OnInit, AfterViewInit, OnDestroy {

    readonly env = environment;
    scoreOptions = [
        {value: 100, viewValue: '100%', className: 'score-100'},
        {value: 90, viewValue: '90%', className: 'score-90'},
        {value: 80, viewValue: '80%', className: 'score-80'},
        {value: 70, viewValue: '70%', className: 'score-70'}
    ];

    authUser: firebase.User | null;
    transactionRule: TransactionRule;
    ruleFormGroup: FormGroup;
    managenmentType: ManagementType;
    now = new Date();

    // step 1. bankaccounts
    readonly maxBankAccounts = 10;
    selectedBankAccounts: BankAccounts = [];
    hitsBankAccounts: BankAccounts[];
    hitsBookingsAccounts: NahausBookingsAccount[];
    hitsProperties: Property[];
    searchBankAccounts: any;
    searchBookingAccounts: any;
    searchProperties: any;
    searchStarted: boolean;
    saving: boolean;
    searchStatusMap = new Map<string, boolean>();
    unitsMap: Map<number, PropertyUnit[]> = new Map();
    periodsMap: Map<number, PropertyUnitPeriod[]> = new Map();
    managementsMap: Map<number, ManagementUnitPeriod[]> = new Map();
    private unsubscribeAll: Subject<any> = new Subject<any>();


    // algolia
    refineQuery = debounce((search, value: string) => {
        if (!value || value.trim().length < 2) {
            return;
        }
        search?.helper?.setQuery(value)?.search();
    }, 350);

    /**
     * Constructor
     */
    constructor(@Inject(MAT_DIALOG_DATA) public data: TransactionRuleDialogData,
                private fb: FormBuilder,
                private transactionsRuleService: TransactionsRulesService,
                private unitsService: UnitsService,
                private periodsService: PeriodsService,
                private managementPeriodsService: ManagementPeriodsService,
                private transactionsActivitiesService: TransactionsRulesActivitiesService,
                private snackbar: MatSnackBar,
                public matDialogRef: MatDialogRef<CreateTransactionRuleDialogComponent>) {
        this.transactionRule = this.data?.rule;
    }

    get selectedBankAccountsFormArray(): FormArray {
        return this.ruleFormGroup.get('selectedBankAccounts') as FormArray;
    }

    get conditions(): FormArray {
        return this.ruleFormGroup.get('conditions') as FormArray;
    }

    get expensesAssignments(): FormArray {
        return this.ruleFormGroup.get('expensesAssignments') as FormArray;
    }

    get bookingsAssignments(): FormArray {
        return this.ruleFormGroup.get('bookingsAssignment') as FormArray;
    }


    ngOnInit(): void {
        this.authUser = this.transactionsRuleService?.authService?.authUser;
        this.ruleFormGroup = this.createRuleFormGroup(this.transactionRule);

        this.listenOnBookingAssignmentsChanges();
        this.listenOnTargetTypeChange();
        this.listenOnSelectedBankAccountsChange();
        this.listenOnTargetAutoSollChange();
        this.listenOnRequireTransactionIbanChange();

        this.adjustValidators(this.transactionRule?.targetType);
        this.updateTransactionIbanValidators(this.ruleFormGroup.get('requireTransactionIban')?.value);

        console.log("rules form group ->", this.ruleFormGroup);
        console.log('Loaded rule with conditions:', this.transactionRule?.conditions);
    }

    ngAfterViewInit(): void {
        this.algoliaAutoCompleteSetup();
    }

    ngOnDestroy(): void {

        this.unsubscribeAll.next(null);
        this.unsubscribeAll.complete();
    }

    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: any): any {
        return item?.id || index;
    }

    get selectedBankAccountsFA(): FormArray {
        return this.ruleFormGroup.get('selectedBankAccounts') as FormArray;
    }

    createRuleFormGroup(transactionRule?: TransactionRule) {
        return this.fb.group({
            id: transactionRule?.id || this.transactionsRuleService.createID(),
            customerID: transactionRule?.customerID || this.transactionsRuleService.authService.customerID,
            createdAt: transactionRule?.createdAt ? convertTimestamp(transactionRule.createdAt) : this.now,
            updatedAt: transactionRule?.updatedAt ? convertTimestamp(transactionRule.updatedAt) : this.now,
            name: this.fb.control(transactionRule?.name, [Validators.required, Validators.maxLength(80)]),
            activated: this.fb.control(transactionRule?.activated ?? true),
            requireTransactionIban: this.fb.control(transactionRule?.requireTransactionIban ?? true),
            transactionIban: this.fb.control(transactionRule?.transactionIban || null, [Validators.required, Validators.pattern(/^[A-Z]{2}[0-9]{2}[A-Z0-9]{11,30}$/)]),
            forAllBankAccounts: this.fb.control(transactionRule?.forAllBankAccounts ?? false),
            selectedBankAccounts: this.fb.array(transactionRule?.selectedBankAccounts || []),
            conditions: this.fb.array(transactionRule?.conditions ? transactionRule?.conditions.map(condition => this.createConditionGroup(condition)) : [this.createConditionGroup()]),  // Leeres Array, in das Bedingungen eingefügt werden
            targetType: this.fb.control(transactionRule?.targetType ?? RuleTargetType.EXPENSE, Validators.required),
            expensesAssignments: this.fb.array(
                transactionRule?.expensesAssignments?.length > 0
                    ? transactionRule.expensesAssignments.map(assignment => this.createExpenseAssignmentGroup(assignment))
                    : [this.createExpenseAssignmentGroup()]
            ),
            bookingsAssignment: this.fb.array(
                transactionRule?.bookingsAssignment?.map(b => this.createBookingAssignmentGroup(b)) || [this.createBookingAssignmentGroup()]
            ),
            autoSoll: this.fb.control(transactionRule?.autoSoll ?? false),
            minimumScoreRequired: this.fb.control(transactionRule?.minimumScoreRequired, transactionRule?.autoSoll ? Validators.required : null)
        })
    }

    createExpenseAssignmentGroup(assignment?: ExpenseAssigment): FormGroup {
        return this.fb.group({
            property: this.fb.control(assignment?.property, Validators.required),
            nahausBookingsAccount: this.fb.control(assignment?.nahausBookingsAccount, Validators.required),
            includesVAT: this.fb.control(assignment?.includesVAT ?? true),
            vatRate: this.fb.control(assignment?.vatRate ?? 19, !!assignment?.includesVAT ? [Validators.required, Validators.min(0)] : Validators.min(0)),
        });
    }

    createBookingAssignmentGroup(assignment?: BookingAssignment): FormGroup {
        return this.fb.group({
            property: this.fb.control(assignment?.property, Validators.required),
            unit: this.fb.control(assignment?.unit, Validators.required),
            period: this.fb.control(assignment?.period, Validators.required),
        });
    }


    addExpenseAssignment(assignment?: ExpenseAssigment): void {
        if (this.expensesAssignments.length < 10) {
            this.expensesAssignments.push(this.createExpenseAssignmentGroup(assignment));
        }
    }

    removeExpenseAssignment(index: number): void {
        this.expensesAssignments.removeAt(index);
    }

    addBookingAssignment(assignment?: BookingAssignment): void {
        const newGroup = this.createBookingAssignmentGroup(assignment);
        this.bookingsAssignments.push(newGroup);

        const index = this.bookingsAssignments.length - 1;
        newGroup?.get('property')?.valueChanges
            .pipe(takeUntil(this.unsubscribeAll), startWith(newGroup?.get('property')?.value))
            .subscribe((property: Property) => {
                if (property?.id) {
                    this.managenmentType = property?.managementType;
                    this.loadUnitsForProperty(property.id, index);
                }
            });
    }


    removeBookingAssignment(index: number): void {
        this.bookingsAssignments.removeAt(index);
    }


    // createBookingAssignmentGroup(assignment?: BookingAssignment): FormGroup {
    // return this.fb.group({
    //     property: this.fb.control(assignment?.propertyID, Validators.required),
    //     nahausBookingsAccount: this.fb.control(assignment?.nahausBookingsAccount, Validators.required),
    //     includesVAT: this.fb.control(assignment?.includesVAT ?? true),
    //     vatRate: this.fb.control(assignment?.vatRate || 19, [Validators.required, Validators.min(0)]),
    // });
    // }

    createConditionGroup(condition?: TransactionRuleCondition): FormGroup {

        let value: any = condition?.value || '';
        // Convert to Date if field is 'date' and value is a string or Firestore Timestamp
        if (condition?.field === 'date') {
            value = convertTimestamp(value);
        }

        return this.fb.group({
            // Das Feld, das geprüft werden soll (z. B. "amount", "usage", "date", "name")
            field: [condition?.field || '', Validators.required],
            // Der Vergleichsoperator (z. B. "EQUAL", "CONTAINS", "LESS_THAN", "BETWEEN" etc.)
            operator: [condition?.operator || '', Validators.required],
            // Der Vergleichswert (für "BETWEEN" evtl. komplexer, hier als einfacher Wert definiert)
            value: [value || '', [Validators.required, Validators.maxLength(100)]],
        });

    }

    // property: h_id id address unit: id w_id label currentPeriod // period: all

    addCondition(): void {
        this.conditions.push(this.createConditionGroup());
    }

    removeCondition(index: number): void {
        this.conditions.removeAt(index);
    }

    // Methode, die beim Ändern des Feldes aufgerufen wird
    onFieldChanged(event: MatSelectChange, index: number): void {
        console.log("onFieldChanged event value ->", event.value);
        // Greife auf das entsprechende FormGroup im FormArray zu
        const conditionGroup = this.conditions.at(index) as FormGroup;
        // Setze den "value"-Control zurück
        conditionGroup.get('value')?.patchValue(null);
        // Optional: Du könntest auch den Operator zurücksetzen, falls sich die möglichen Operatoren ändern
        conditionGroup.get('operator')?.patchValue(null);
    }

    algoliaAutoCompleteSetup() {

        this.searchBankAccounts = instantsearch({
            indexName: environment.algolia.indexName.bankAccounts,
            searchClient: this.transactionsRuleService.authService.getAlgoliaSearchClient(true)
        });

        this.searchBankAccounts.addWidget(
            hits({
                container: '#hits',
                templates: {
                    item: ``
                }
            })
        );

        this.searchProperties = instantsearch({
            indexName: environment.algolia.indexName.properties,
            searchClient: this.transactionsRuleService.authService.getAlgoliaSearchClient(true)
        });

        this.searchProperties.addWidget(
            hits({
                container: '#propertiesHits',
                templates: {
                    item: ``
                }
            })
        );

        this.searchBookingAccounts = instantsearch({
            indexName: environment.algolia.indexName.nahausBookingsAccounts,
            searchClient: this.transactionsRuleService.authService.getAlgoliaSearchClient(true)
        });

        this.searchBookingAccounts.addWidget(
            hits({
                container: '#bookingAccountsHits',
                templates: {
                    item: ``
                }
            })
        );


        // // Adding a configure widget to filter results
        environment.pool && this.searchBankAccounts.addWidget(
            configure({
                filters: `customerID:${this.transactionsRuleService.authService.customerID}`
            })
        );

        environment.pool && this.searchProperties.addWidget(
            configure({
                filters: `customerID:${this.transactionsRuleService.authService.customerID}`
            })
        );

        environment.pool && this.searchBookingAccounts.addWidget(
            configure({
                filters: `customerID:${this.transactionsRuleService.authService.customerID}`
            })
        );

        this.searchBankAccounts.on('render', () => {
            const results = this.searchBankAccounts.renderState[environment.algolia.indexName.bankAccounts].hits;
            this.hitsBankAccounts = results.hits;
            console.log("bank accounts hits results:", this.hitsBankAccounts);
        });

        this.searchProperties.on('render', () => {
            const results = this.searchProperties.renderState[environment.algolia.indexName.properties].hits;
            this.hitsProperties = results.hits;
            console.log("properties hits results:", this.hitsProperties);
        });

        this.searchBookingAccounts.on('render', () => {
            const results = this.searchBookingAccounts.renderState[environment.algolia.indexName.nahausBookingsAccounts].hits;
            this.hitsBookingsAccounts = results.hits;
            console.log("bookings accounts hits results:", this.hitsBookingsAccounts);
        });

    }

    // startSearch(): void {
    //     if (!this.searchStarted) {
    //         this.searchBankAccounts.start();
    //         this.searchStarted = true;
    //     }
    // }

    startSearch(search: string): void {
        if (!this.searchStatusMap.get(search)) {
            switch (search) {
                case 'bankAccounts':
                    this.searchBankAccounts.start();
                    break;
                case 'properties':
                    this.searchProperties.start();
                    break;
                case 'bookingAccounts':
                    this.searchBookingAccounts.start();
                    break;
            }
            this.searchStatusMap.set(search, true); // Update the status map
        }
    }

    onQueryBankAccountsSuggestionClick(bankAccount: BankAccount): void {
        // Prüfen, ob das Bankkonto bereits existiert:
        const index = this.selectedBankAccountsFormArray.controls.findIndex(ctrl => ctrl.value.id === bankAccount.id);

        // Auswahl nur hinzufügen, wenn noch nicht am Limit
        if (this.selectedBankAccountsFA?.length >= this.maxBankAccounts) {
            return;
        }

        // add only if bankaccount not already added
        if (index < 0) {
            // Optional: Hier kannst du auch ein FormGroup mit zusätzlichen Validierungen aufbauen.
            this.selectedBankAccountsFormArray.push(this.fb.group({
                id: [bankAccount?.id],
                bank: [bankAccount?.bank],
                IBAN: [bankAccount?.IBAN],
                accountHolder: [bankAccount?.accountHolder],
                img: [bankAccount?.img],
                notes: [bankAccount?.notes]
            }));
        }
    }


    removeBankAccount(bankAccountId: string): void {
        const index = this.selectedBankAccountsFormArray.controls.findIndex(ctrl => ctrl.value.id === bankAccountId);
        if (index >= 0) {
            this.selectedBankAccountsFormArray.removeAt(index);
        }
    }

    onQueryPropertySuggestionClick(property: Property, index: number): void {
        console.log('onQueryPropertySuggestionClick --> ', property);
        this.expensesAssignments.at(index).get('property').patchValue(pick(property, ['id', 'h_id', 'address', 'img', 'thumbs', 'managementType']));
    }

    onQueryPropertySuggestionClick2(property: Property, index: number): void {
        console.log('onQueryPropertySuggestionClick --> ', property);
        this.bookingsAssignments.at(index).get('property').patchValue(pick(property, ['id', 'h_id', 'address', 'img', 'thumbs', 'managementType']));
        //this.listenOnBookingAssignmentsChanges();
    }

    onQueryBookingAccountSuggestionClick(bookingAccount: NahausBookingsAccount, index: number): void {

        console.log('onQueryBookingAccountSuggestionClick --> ', bookingAccount, "index ->", index);
        this.expensesAssignments.at(index).get('nahausBookingsAccount').patchValue(bookingAccount);
        console.log("updated expenses assignments array -> ", this.ruleFormGroup.get('expensesAssignments').value);
    }

    removeBookingAccount(index: number) {

        this.expensesAssignments.at(index).get('nahausBookingsAccount').patchValue(null);
        console.log("updated expenses assignments array -> ", this.ruleFormGroup.get('expensesAssignments').value);
    }

    updateVATFields(index: number, includesVAT: boolean, vatRate?: number): void {
        console.log(`Updating VAT for index ${index}: includesVAT=${includesVAT}, vatRate=${vatRate}`);
        const assignmentGroup = this.expensesAssignments.at(index) as FormGroup;
        if (assignmentGroup) {
            assignmentGroup.get('includesVAT').patchValue(includesVAT);
            if (includesVAT) {
                assignmentGroup.get('vatRate').patchValue(vatRate || 19); // Default VAT rate 19% if not provided
            } else {
                assignmentGroup.get('vatRate').patchValue(null); // Reset VAT rate when not applicable
            }
        }
    }

    onVATChange(index: number, event: MatCheckboxChange): void {
        this.updateVATFields(index, event.checked);
    }

    save() {

        if (this.ruleFormGroup?.invalid) {
            // Zeige eine deutliche Fehlermeldung
            this.snackbar.open(
                'Regel konnte nicht gespeichert werden. Bitte füllen Sie alle Pflichtfelder korrekt aus.',
                'OK',
                {duration: 5000}
            );

            // Alle Controls als "touched" markieren, damit Validierungsfehler sichtbar werden
            this.ruleFormGroup.markAllAsTouched();
            return;
        }

        // ... Speichern der Regel ...

        this.saving = true;

        // Get the raw form values
        let rule: TransactionRule = this.ruleFormGroup.getRawValue() as TransactionRule;

        if (!rule.requireTransactionIban) {
            rule.transactionIban = null;
        }

        rule.transactionIbanList = rule.requireTransactionIban && rule.transactionIban
            ? [rule.transactionIban]
            : null;


        console.log("rule data ->", rule);

        if (rule.forAllBankAccounts || (rule.selectedBankAccounts?.length === 0)) {
            rule.forAllBankAccounts = true;
            rule.selectedBankAccounts = null;
            rule.bankAccountsIdList = null;
            rule.targetIbanList = null;
        } else {
            rule.bankAccountsIdList = uniq(rule.selectedBankAccounts?.map(bankAccount => bankAccount?.id))
            rule.targetIbanList = uniq(rule.selectedBankAccounts?.map(bankAccount => bankAccount?.IBAN))
        }

        if (rule.targetType === RuleTargetType.EXPENSE) {
            if (rule?.expensesAssignments?.length > 0) {
                rule.propertiesIdList = uniq(rule.expensesAssignments.map(assignment => assignment?.property?.id));
            }

            // Clean only the property and nahausBookingsAccount objects inside expensesAssignments\

            let assignments = this.expensesAssignments.getRawValue();

            assignments = assignments.map((e) => ({

                ...e,
                property: e.property ? omit(e.property, ['__position', '_highlightResult']) : null,
                nahausBookingsAccount: e.nahausBookingsAccount ? omit(e.nahausBookingsAccount, ['__position', '_highlightResult']) : null
            }));

            console.log("assignments lol", assignments);

            rule.expensesAssignments = assignments;

            if (rule?.expensesAssignments?.length > 0) {
                rule.nahausBookingsIdList = uniq(rule.expensesAssignments.map(assignment => assignment?.nahausBookingsAccount?.id));
            } else {
                rule.nahausBookingsIdList = null;
            }
        } else {
            rule.expensesAssignments = null;

            const bookings = this.bookingsAssignments.getRawValue();

            // Clean property, unit, and period objects
            rule.bookingsAssignment = bookings.map(b => ({
                ...b,
                property: b.property ? omit(b.property, ['__position', '_highlightResult']) : null,
                unit: b.unit ? omit(b.unit, ['__position', '_highlightResult']) : null,
                period: b.period ? omit(b.period, ['__position', '_highlightResult']) : null,
            }));

            // Extract IDs into lists
            rule.propertiesIdList = uniq(rule.bookingsAssignment.map(b => b?.property?.id).filter(Boolean));
            rule.unitsId = uniq(rule.bookingsAssignment.map(b => b?.unit?.id).filter(Boolean));
            rule.periodsId = uniq(rule.bookingsAssignment.map(b => b?.period?.id).filter(Boolean));

            console.log("cleaned bookingsAssignment ->", rule.bookingsAssignment);
        }


        // // Save to Firestore with cleaned data
        this.transactionsRuleService.doc(rule.id).set(rule, {merge: true})
            .then(() => {
                this.snackbar.open(this.transactionRule ? 'Regel erfolgreich aktualisiert.' : 'Regel erfolgreich erstellt.', 'OK', {duration: 5000});
                this.saving = false;
                this.matDialogRef.close();
                this.createActivity(rule?.id);
            })
            .catch(err => console.error("Error saving rule ->", err));

        // console.log("Form group value on save ->", cleanedRules);
    }

    isConditionFieldDisabled(field: string, currentIndex: number): boolean {
        return this.conditions.controls.some((ctrl, index) =>
            ctrl.get('field')?.value === field && index !== currentIndex
        );
    }

    listenOnBookingAssignmentsChanges(): void {
        this.bookingsAssignments?.controls?.forEach((group, index) => {
            group?.get('property')?.valueChanges.pipe(takeUntil(this.unsubscribeAll), startWith(group?.get('property')?.value)).subscribe((property: Property) => {
                if (property?.id) {
                    this.managenmentType = property?.managementType;
                    this.loadUnitsForProperty(property.id, index);
                }
                const unit = group?.get('unit')?.value;
                if (unit?.id) {
                    //this.loadPeriods(index);
                }
            });
        });
    }

    loadUnitsForProperty(propertyId: string, index: number): void {
        this.unitsService
            .collectionWithParent(`properties/${propertyId}`, ref => ref.orderBy('w_id'))
            .get()
            .subscribe(snapshot => {
                const units: PropertyUnit[] = [];
                snapshot.forEach(doc => {
                    const data = doc.data();
                    const unitBase = {
                        id: doc.id,
                        w_id: data.w_id,
                        label: data.label,
                        address: data.address
                    };

                    units.push({
                        ...unitBase,
                        ...(this.managenmentType !== ManagementType.WEG
                            ? {currentPeriod: data.currentPeriod}
                            : {currentManagement: data.currentManagement})
                    });
                });
                this.unitsMap.set(index, units);
                console.log("units for selected property->", units);
            });
    }

    onUnitChange(event: MatSelectionListChange, index: number): void {
        const selectedUnit = event.options[0]?.value;
        if (selectedUnit) {
            const assignmentGroup = this.bookingsAssignments.at(index);
            assignmentGroup.get('unit')?.patchValue(selectedUnit);
            console.log("unit selected ->", this.bookingsAssignments.at(index));
            assignmentGroup.get('period')?.reset();
            //this.loadPeriodsForUnit(selectedUnit?.id, assignmentGroup.get('property')?.value?.id);
        }
    }

    loadPeriods(index: number) {
        const assignmentGroup = this.bookingsAssignments.at(index);
        const selectedProperty = assignmentGroup.get('property').value;
        const selectedUnit = assignmentGroup.get('unit').value;
        this.periodsService.collectionWithParent(`properties/${selectedProperty?.id}/units/${selectedUnit?.id}`, ref => ref.where('rental.isRented', '==', true).orderBy('rental.startDate', 'desc').limit(3))
            .get().pipe(takeUntil(this.unsubscribeAll),
            map((query: QuerySnapshot<PropertyUnit>) => {
                console.log('periods query', query?.docs, query?.size);
                return query?.size > 0 ? query.docs.map(doc => doc.data() as PropertyUnitPeriod) : [];
            })
        )
            .subscribe((periods) => {
                console.log("periods for selected unit ->", periods);
                this.periodsMap.set(index, periods);
            });
    }

    onUnitSelection(index: number, unit: PropertyUnit) {
        if (unit?.currentManagement) {
            this.loadManagements(index);
        } else {
            this.loadPeriods(index);
        }
    }

    loadManagements(index: number) {
        const assignmentGroup = this.bookingsAssignments.at(index);
        const selectedProperty = assignmentGroup.get('property').value;
        const selectedUnit = assignmentGroup.get('unit').value;
        this.managementPeriodsService.collectionWithParent(`properties/${selectedProperty?.id}/units/${selectedUnit?.id}`, ref => ref.orderBy('startDate', 'desc').limit(3))
            .get().pipe(takeUntil(this.unsubscribeAll),
            map((query: QuerySnapshot<ManagementUnitPeriod>) => {
                console.log('periods query', query?.docs, query?.size);
                return query?.size > 0 ? query.docs.map(doc => doc.data() as ManagementUnitPeriod) : [];
            })
        )
            .subscribe((managements) => {
                console.log("managements for selected unit ->", managements);
                this.managementsMap.set(index, managements);
            });
    }

    onPeriodChange(event: MatSelectionListChange, index: number): void {
        const selectedPeriod = event.options[0]?.value;
        if (selectedPeriod) {
            const assignmentGroup = this.bookingsAssignments.at(index);
            assignmentGroup.get('period')?.patchValue(selectedPeriod);
            console.log("period selected ->", this.bookingsAssignments.at(index));
        }
    }

    resetBookingAssignment(index: number) {

        this.bookingsAssignments.at(index).reset();
    }

    clearValidatorsFromFormArray(formArray: FormArray, formArray2: FormArray): void {
        formArray?.controls?.forEach((group: FormGroup) => {
            Object.keys(group.controls).forEach((key: string) => {
                const control = group.get(key);
                control?.clearValidators();
                control?.setValue(null);
                control?.updateValueAndValidity();
            });
        });

        formArray2?.controls?.forEach((group: FormGroup) => {
            Object.keys(group.controls).forEach((key: string) => {
                const control = group.get(key);
                control?.setValidators(Validators.required);
                control?.updateValueAndValidity();
            });
        });
    }

    listenOnTargetTypeChange() {
        this.ruleFormGroup.get('targetType')?.valueChanges
            .pipe(takeUntil(this.unsubscribeAll))
            .subscribe((targetType: RuleTargetType) => {
                this.adjustValidators(targetType);
            });
    }

    listenOnTargetAutoSollChange() {
        this.ruleFormGroup.get('autoSoll')?.valueChanges
            .pipe(takeUntil(this.unsubscribeAll))
            .subscribe((value: boolean) => {
                if (value) {
                    console.log("autosoll value ->", value);
                    this.ruleFormGroup.get('minimumScoreRequired').setValidators(Validators.required);
                } else {
                    console.log("autosoll value ->", value);
                    this.ruleFormGroup.get('minimumScoreRequired').setValue(null);
                    this.ruleFormGroup.get('minimumScoreRequired').clearValidators();
                }
                this.ruleFormGroup.get('minimumScoreRequired').updateValueAndValidity();
            });
    }

    listenOnSelectedBankAccountsChange() {
        this.ruleFormGroup.get('selectedBankAccounts')?.valueChanges
            .pipe(takeUntil(this.unsubscribeAll), skipWhile(() => !!this.transactionRule?.id))
            .subscribe((selectedBankAccounts: BankAccount[]) => {
                console.log("listenOnSelectedBankAccountsChange --> selected bank accounts ->", selectedBankAccounts);
                if (selectedBankAccounts?.length > 0) {
                    const allHypoVereinsbank = selectedBankAccounts.every(bankAccount => {
                        return bankAccount.bank === 'HypoVereinsbank'
                    })
                    if (allHypoVereinsbank) {
                        this.ruleFormGroup.get('requireTransactionIban')?.setValue(false);
                        console.log("allHypoVereinsbank ->", allHypoVereinsbank, this.ruleFormGroup.get('requireTransactionIban')?.value);
                    }
                }
            });
    }

    listenOnRequireTransactionIbanChange(): void {
        this.ruleFormGroup.get('requireTransactionIban')?.valueChanges
            .pipe(takeUntil(this.unsubscribeAll))
            .subscribe((required: boolean) => {
                this.updateTransactionIbanValidators(required);
            });
    }

    updateTransactionIbanValidators(required: boolean): void {
        const ibanControl = this.ruleFormGroup.get('transactionIban');

        if (!ibanControl) return;

        if (required) {
            ibanControl.setValidators([
                Validators.required,
                Validators.pattern(/^[A-Z]{2}[0-9]{2}[A-Z0-9]{11,30}$/)
            ]);
        } else {
            ibanControl.setValidators([
                Validators.pattern(/^[A-Z]{2}[0-9]{2}[A-Z0-9]{11,30}$/)
            ]);
        }

        ibanControl.updateValueAndValidity();
    }

    adjustValidators(targetType: RuleTargetType) {
        if (targetType === RuleTargetType.BOOKING) {
            // Clear validators from expensesAssignments
            this.clearValidatorsFromFormArray(this.expensesAssignments, this.bookingsAssignments);
        } else {
            this.clearValidatorsFromFormArray(this.bookingsAssignments, this.expensesAssignments);
        }

    }

    createActivity(id: string): void {

        const isUpdate = !!this.transactionRule; // or !!transactionRule?.id
        const description = `<strong>${this.authUser?.displayName}</strong> ` + (isUpdate
            ? 'hat die Regel aktualisiert.'
            : 'hat eine neue Regel erstellt.');

        const activity: TransactionRuleActivity = {
            user: this.authUser?.uid,
            icon: 'heroicons_outline:pencil',
            description: description,
            date: new Date()
        };

        this.transactionsActivitiesService.setParentPath(id);

        this.transactionsActivitiesService
            .collection()
            .add(activity)
            .then((res) => {
                console.log('activity has been added', res);
            })
            .catch(
                (err) => {
                    console.error('Error', err)
                    this.snackbar.open('Error adding activity: ' + err.message, 'Close', {
                        duration: 5000,
                        panelClass: ['snackbar-error']
                    });
                }
            );
    }
}
